// 热键
// 加粗：ctrl+b
// 斜体：ctrl+i
// 下划线：ctrl+u
// 代码：ctrl+`
export const HOTKEYS = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline',
  'mod+`': 'code',
}
